// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__1OHWD","overlay":"styles_overlay__YRyOQ","modal":"styles_modal__1oK77","title":"styles_title__rVn0S","btnClose":"styles_btnClose__3PHVB"};